// extracted by css-extract-rspack-plugin
export default {"panel":"GeneralTabPanel_panel__wn46z","mobile":"GeneralTabPanel_mobile__lLdyA"};